// Scale reference options (CLAUDE.md §6.1).
//
// Each option carries the value stored in journal.photos[].scaleObject so the
// calibration math (Phase 3 ML / tap-to-measure) knows which object to expect.
//
// `dimMm` is the canonical dimension (diameter for circles, cell spacing for
// the grid). `null` means user-supplied (custom).

export const SCALE_REFS = [
  { id: 'GBP-2p-25.9mm',    label: '2p coin',          dimMm: 25.9, shape: 'circle', defaultRound: true },
  { id: 'paper-1cm-grid',   label: '1 cm graph paper', dimMm: 10.0, shape: 'grid',   defaultFlat:  true },
  { id: 'GBP-2pound-28.4mm',label: '£2 coin',          dimMm: 28.4, shape: 'circle' },
  { id: 'GBP-10p-24.5mm',   label: '10p coin',         dimMm: 24.5, shape: 'circle' },
  { id: 'GBP-1p-20.3mm',    label: '1p coin',          dimMm: 20.3, shape: 'circle' },
  { id: 'GBP-5p-18.0mm',    label: '5p coin',          dimMm: 18.0, shape: 'circle' },
  { id: 'custom',           label: 'Custom (mm)',      dimMm: null, shape: 'unknown' },
];

/**
 * Resolve the selected scale-ref id to the stored `scaleObject` value.
 * If the user picked "custom", emit `custom-<mm>mm` so the dimension survives.
 */
export function resolveScaleObject(selectedId, customMm) {
  if (selectedId !== 'custom') return selectedId;
  const mm = Number(customMm);
  if (!Number.isFinite(mm) || mm <= 0) return null;
  return `custom-${mm}mm`;
}
